export default __webpack_public_path__ + "static/bo-52e1cc3d96985356b51a04714ec83d98.svg";